<template>
  <div class="safe-loading-container">
    <span>4</span>
    <span>0</span>
    <span>4</span>
  </div>
</template>

<script>
export default {
  name: "NotFound",
};
</script>

<style>
.safe-loading-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  width: 100%;
  height: 100vh;
  font-size: 42px;
  letter-spacing: 6px;
  font-weight: 600;
  background: #fff;
  overflow: hidden;
}

.safe-loading-container span {
  color: #f5c17c;
  animation: colorChange 1s infinite ease-in-out alternate;
}

@keyframes colorChange {
  to {
    color: #f33d46;
  }
}

.safe-loading-container span:nth-child(1) {
  animation-delay: 0s;
}

.safe-loading-container span:nth-child(2) {
  animation-delay: 0.2s;
}

.safe-loading-container span:nth-child(3) {
  animation-delay: 0.4s;
}
</style>